import { render, staticRenderFns } from "./SettingPromotionProductNew.vue?vue&type=template&id=a76fed08&scoped=true&"
import script from "./SettingPromotionProductNew.vue?vue&type=script&lang=js&"
export * from "./SettingPromotionProductNew.vue?vue&type=script&lang=js&"
import style0 from "./SettingPromotionProductNew.vue?vue&type=style&index=0&id=a76fed08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a76fed08",
  null
  
)

export default component.exports